import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationRoleUpdateArgs, QueryRoleArgs, Role } from "types/generated";

import { RoleView } from "./types";

type RoleData = {
  role: RoleView;
};

export const GET_ROLE: TypedDocumentNode<RoleData, QueryRoleArgs> = gql`
  query GetRole($id: ID!) {
    role(id: $id) {
      id
      name
      description
      actions
      isSystem
      roleBindingsCount
      roleBindings {
        ... on UserRoleBinding {
          __typename
          id
          space {
            id
            name
          }
          user {
            id
            username
          }
        }
        ... on UserGroupRoleBinding {
          __typename
          id
          space {
            id
            name
          }
          userGroup {
            id
            groupName
          }
        }

        ... on ApiKeyRoleBinding {
          __typename
          id
          space {
            id
            name
          }
          apiKey {
            id
            name
          }
        }
        ... on StackRoleBinding {
          __typename
          id
          space {
            id
            name
          }
          stackID
          stackName
        }
      }
      slug
    }
  }
`;

type RoleUpdateData = {
  roleUpdate: Pick<Role, "id">;
};

export const ROLE_UPDATE: TypedDocumentNode<RoleUpdateData, MutationRoleUpdateArgs> = gql`
  mutation RoleUpdate($id: ID!, $input: RoleUpdateInput!) {
    roleUpdate(id: $id, input: $input) {
      id
    }
  }
`;
